import { render, staticRenderFns } from "./unitFormatVolumeLabel.vue?vue&type=template&id=a8bd431c&"
import script from "./unitFormatVolumeLabel.vue?vue&type=script&lang=js&"
export * from "./unitFormatVolumeLabel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports